import { createAction } from "@reduxjs/toolkit"

import type { List } from "@/api/lists"
import type { DenormalizedTargetAttribute } from "@/api/templates"
import type { ListAndWorkspaceId } from "@/redux/lists"

// WORKSPACE ACTIONS
// Workspace create/update write directly to the React Query cache (see
// `useWorkspacesCache`). `deleteWorkspaceById` remains because the `lists` slice
// cascades on it to drop the deleted workspace's lists.
export const deleteWorkspaceById = createAction<number>("workspaces/delete-by-id")

// LIST ACTIONS
export const createLists = createAction<List[]>("lists/create")
export const updateList = createAction<Partial<List>>("lists/update")
export const updateListWorkspaceId = createAction<{
  workspaceId: number
  listId: number
  newWorkspaceId: number
}>("lists/move-workspace")
export const deleteListById = createAction<ListAndWorkspaceId>("lists/delete")

// TEMPLATE ACTIONS
// Template create/update write directly to the React Query cache (see
// `useTemplatesCache`). `deleteTemplateById` remains because the `lists` slice
// cascades on it to null out lists referencing the archived template.
export const deleteTemplateById = createAction<number>("templates/delete")

// TARGET ATTRIBUTE ACTIONS
// Target-attribute create/reorder write directly to the React Query cache.
// `updateTargetAttribute` and `deleteTargetAttributeById` remain because the
// `lists` slice cascades on them to mirror/drop list attributes.
export const updateTargetAttribute = createAction<DenormalizedTargetAttribute>(
  "target-attributes/update",
)
export const deleteTargetAttributeById = createAction<{ templateId: number; id: number }>(
  "target-attributes/delete",
)
